"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _lodash = require("lodash");
var _reactSvg = require("react-svg");
var _CountrySelector = _interopRequireDefault(require("../CountrySelector/CountrySelector"));
var _common = require("../../../core/utils/common");
var globalTranslations = function globalTranslations(data) {
  return {
    dismissButton: data.dismissButton,
    cancelButton: data.cancelButton,
    preferredCountryHeading: data.preferredCountryHeading,
    changeCountryText: data.changeCountryText,
    changeCountryNewTabText: data.changeCountryNewTabText,
    changeCountryNoteText: data.changeCountryNoteText,
    changeCountryButton: data.changeCountryButton,
    formCountryLabel: data.formCountryLabel,
    languageText: data.languageText
  };
};
var CountryLanguageSelector = function CountryLanguageSelector(props) {
  var labels = props.labels,
    config = props.config,
    countryName = props.countryName,
    language = props.language,
    countryList = props.countryList,
    languageList = props.languageList,
    disableFooterSelector = props.disableFooterSelector,
    isLanguageListJSON = props.isLanguageListJSON;
  var appHostPath = config.appHostPath,
    globeIcon = config.globeIcon;
  var languageName = (0, _lodash.get)(language, ['title'], '');
  var isDisableCountryLanguage = (0, _common.disableCountryLanguage)(disableFooterSelector);
  var countrySelectorProps = (0, _extends2.default)({}, props, {
    countries: countryList,
    languageList: languageList,
    appHostPath: appHostPath,
    translations: globalTranslations(labels),
    countryName: countryName,
    language: language
  });
  return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement("div", {
    className: "country-language-selector",
    "data-locator": "header__language-selector"
  }, _react.default.createElement("div", {
    className: "country-language-container"
  }, _react.default.createElement("div", {
    className: "cmp-header__selector__region " + (isDisableCountryLanguage ? 'disabled' : '')
  }, _react.default.createElement("div", {
    className: "row country-language-content",
    "data-locator": "header__selector"
  }, _react.default.createElement(_reactSvg.ReactSVG, {
    src: globeIcon,
    wrapper: "span",
    "data-locator": "header__selector-icon"
  }), !isLanguageListJSON && countryName && _react.default.createElement("span", {
    "data-locator": "header__selector__region-text"
  }, countryName), !isLanguageListJSON && languageName && _react.default.createElement("span", {
    className: "separator",
    "data-locator": "separator"
  }, "|"), _react.default.createElement("span", {
    "data-locator": "header-language-link"
  }, languageName))))), _react.default.createElement(_CountrySelector.default, countrySelectorProps));
};
CountryLanguageSelector.defaultProps = {
  countryName: '',
  languageName: '',
  countryList: [],
  languageList: [],
  isLanguageListJSON: false
};
var _default = CountryLanguageSelector;
exports.default = _default;
module.exports = exports["default"];